/** ダッシュボードウィジェットのメトリクスの累積期間 */
export type AccumulationType = 'NONE' | 'HOUR' | 'DAY';
export const AccumulationTypes: AccumulationType[] = ['NONE', 'HOUR', 'DAY'];
export function convertAccumulationType(s?: string) {
  for (const v of AccumulationTypes) if (v === s) return s;
  return AccumulationTypes[0];
}
